const updateCompaniesStr = {
  toastr: 'Empresa atualizada',
  toastr1: ' foi atualizada com sucesso',
  toastrError: 'Empresa já cadastrado',
  toastrError1: 'Insira este CNPJ ou Nome já foi cadastrado'
};

export default updateCompaniesStr;
